<script lang="ts" module>
	import type { Component } from "svelte";
	import type { ContentBlock, SavedContentBlock } from "@core/schema/ContentBlock.js";
	import { ContentType } from "@core/schema/ContentType.js";
	import { contentBlockSchemaMap as schemaMap } from "@core/schema/contentBlockSchemaMap.js";
	import BrownCardBlock from "./BrownCardBlock.svelte";
	import ButtonBlock from "./ButtonBlock.svelte";
	import CkEditorBlock from "./CkEditorBlock.svelte";
	import type { ContentBlockComponentProps } from "./ContentBlockComponentProps.js";
	import GalleryBlock from "./GalleryBlock.svelte";
	import ImageTextBlock from "./ImageTextBlock.svelte";
	import VideoTextBlock from "./VideoTextBlock.svelte";

	const componentMap: { [T in ContentType]: Component<ContentBlockComponentProps<T>> } = {
		[ContentType.CKEditor]: CkEditorBlock,
		[ContentType.Gallery]: GalleryBlock,
		[ContentType.BrownCard]: BrownCardBlock,
		[ContentType.ImageText]: ImageTextBlock,
		[ContentType.VideoText]: VideoTextBlock,
		[ContentType.Button]: ButtonBlock,
	};
</script>

<script lang="ts">
	const {
		block,
		lightboxId,
		narrowText,
	}: { block: SavedContentBlock | ContentBlock; lightboxId: string | undefined; narrowText: boolean } = $props();
	const Component = $derived(componentMap[block.type]);
	const data = $derived(
		schemaMap[block.type].parse(typeof block.data === "string" ? JSON.parse(block.data) : block.data) as never,
	);
</script>

<Component {data} {lightboxId} {narrowText} />
